/**
 * №13.1 (§2.10) — the firm-wide Register of Powers & Estates (`/app/registers`).
 * Mirrors the statutory R13 columns (donor/deceased · kind · date of power · date
 * of death · responsible lawyer). The statutory PDF renderer reads these same
 * entity rows (Stage-D re-point). Per-matter entries are added from the matter's
 * Register tab (the №11.1 contextual action); this list is read-only + firm-wide.
 */
import { useNavigate } from "react-router";
import { useRegisterEntries } from "../../hooks/use-time-billing";
import { TableSubjectHead } from "./TableSubjectHead";

export function RegistersPage() {
  const navigate = useNavigate();
  const entries = useRegisterEntries();
  const rows = entries.data ?? [];

  // №14.1.1-B — was a `.surface`/`.surface__bar` page title (the ledger record
  // header) wrapping a border-stripped card, with a zero-padded footnote that
  // rendered OUTSIDE the card's left edge. Now the same pagehead + card as every
  // other Place list. The build commentary ("the statutory renderer reads these
  // rows", "Stage-D re-point — proven on dev") is gone: it was engineering
  // provenance, not product copy.
  return (
    <div className="screen">
      <TableSubjectHead
        title="Register of Powers &amp; Estates"
        sub={<>R13 · {rows.length} entr{rows.length === 1 ? "y" : "ies"} · firm-wide · entries are added from a matter's Register tab</>}
      />
      <div className="card card--flush">
        {entries.isLoading ? (
          <div className="skeleton"><div className="sk-line" style={{ width: "60%" }} /><div className="sk-line" style={{ width: "40%" }} /></div>
        ) : rows.length === 0 ? (
          <div className="empty-state">
            <h3>No register entries yet</h3>
            <p>Add register entries from a matter's Register tab.</p>
          </div>
        ) : (
          <div className="table-scroll">
            <table>
              <thead><tr><th>Donor / deceased</th><th>Kind</th><th>Matter</th><th>Date of power</th><th>Date of death</th><th>Lawyer</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} onClick={() => navigate(`/app/place/matter/${r.matter as string}`)} style={{ cursor: "pointer" }}>
                    <td className="primary">{(r.donor_name as string) ?? "—"}</td>
                    <td><span className="badge badge--neutral">{(r.kind as string) ?? ""}</span></td>
                    <td>{(r.matter as string) ?? "—"}</td>
                    <td className="row-date">{(r.date_of_power as string) ?? "—"}</td>
                    <td className="row-date">{(r.date_of_death as string) ?? "—"}</td>
                    <td className="muted">{(r.responsible_lawyer as string) ?? "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
